import ResponsiveMenuIcon from '../responsiveMenuIcon'
import Logo from '../../../assets/images/logo.svg'
import {Link} from 'react-router-dom'
import {routes} from '../../../routes'

const ResponsivePageTitle = () => {
    return (
        <div className="responsive-page-title">
            <ResponsiveMenuIcon/>
            <Link to={routes.resources.path}><img width="150" height="32" src={Logo} alt="Pinghome"/></Link>
        </div>
    )
}

export default ResponsivePageTitle
